<template>
    <hts-drawer
        v-model="visible"
        :submit="submit"
        :rules="rulesCooperatorCommodity"
        :title="$t('labels.addCommodity')"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-select
                v-model="formData.category"
                :label="$t('labels.category')"
                required
                :items="listCategory"
                key-id="label"
                key-label="label"
                prop="category"
                name="category"
                filterable
                :color="color" />
            <hts-form-input
                v-model="formData.commodity"
                :label="$t('labels.name')"
                :required="true"
                prop="commodity"
                name="commodity"
                :color="color" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import listCategory from '@/data/commodity/category.json'
import { IAddCommodity } from '~/pages/trucker-[id]/partner/-components/imports/form'

const rulesCooperatorCommodity = {
  commodity: 'required',
  category: 'required'
}
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})
const visible = ref(false)
const creating = ref(false)
const cooperatorId = ref('')
const businessOpportunityId = ref<string | undefined>('')
const resetForm = () => {
  Object.assign(formData, {
    cooperator: '',
    commodity: '',
    category: '',
    businessOpportunity: ''
  })
}
const formData = reactive<IAddCommodity>({
  cooperator: '',
  commodity: '',
  category: '',
  businessOpportunity: ''
})
const close = () => {
  visible.value = false
}

const emits = defineEmits(['update:show', 'close', 'actionAddCompanyUser', 'refreshTables', 'newCommodity'])

const open = (id: string, businessOpportunity: string | undefined = undefined) => {
  visible.value = true
  cooperatorId.value = id
  businessOpportunityId.value = businessOpportunity
}

defineExpose({
  open
})

const submit = async () => {
  const api = {
    url: '/partner/commodity/create',
    method: 'post'
  }
  formData.cooperator = cooperatorId.value
  formData.businessOpportunity = businessOpportunityId.value
  const data: any = await $api(api, { body: formData })
  const resData = data?.data?.value

  if (resData && resData.success) {
    if (resData.success) {
      resetForm()
      process.client && $toast().success($t('labels.createCommoditySuccess'))
      close()
      emits('refreshTables')
      emits('newCommodity', resData?.data)
    }
  }
}
</script>
